module.exports = __webpack_public_path__ + "static/img/003.a5354fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/factory/003.jpg
// module id = yxTE
// module chunks = 1